import { APP_VERSION } from '../version'; // Ajuste o caminho conforme necessário
import { Heading } from '@chakra-ui/react';

const VersionInfo: React.FC = () => (
  <Heading size="0xl" mb={0} textAlign="center">
    ({APP_VERSION})
  </Heading>
);

export default VersionInfo;
